let cachedToken = '';
let cachedStatus = null;
let pendingToken = '';
let pendingRequest = null;

export function getCachedOnboardingStatus(token) {
  return token && token === cachedToken ? cachedStatus : null;
}

export function setCachedOnboardingStatus(token, status) {
  if (!token || !['completed', 'pending'].includes(status)) return;
  cachedToken = token;
  cachedStatus = status;
}

export function loadOnboardingStatus(token) {
  if (!token) return Promise.reject(new Error('No hay una sesión activa.'));
  const cached = getCachedOnboardingStatus(token);
  if (cached) return Promise.resolve(cached);
  if (pendingToken === token && pendingRequest) return pendingRequest;

  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 10000);
  pendingToken = token;
  pendingRequest = fetch('/api/onboarding', {
    credentials: 'same-origin',
    headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
    signal: controller.signal,
  }).then(async (response) => {
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.message || data.error || 'No se pudo validar el onboarding.');
    const status = data.onboarding?.status === 'completed' ? 'completed' : 'pending';
    setCachedOnboardingStatus(token, status);
    return status;
  }).catch((error) => {
    if (controller.signal.aborted) {
      throw new Error('La validación del onboarding tardó demasiado. Reintenta para continuar.');
    }
    throw error;
  }).finally(() => {
    window.clearTimeout(timeout);
    if (pendingToken === token) {
      pendingToken = '';
      pendingRequest = null;
    }
  });

  return pendingRequest;
}
